import { render, staticRenderFns } from "./ProAppIntelligenceHeader.vue?vue&type=template&id=f670bc26&scoped=true&"
import script from "./ProAppIntelligenceHeader.vue?vue&type=script&lang=js&"
export * from "./ProAppIntelligenceHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProAppIntelligenceHeader.vue?vue&type=style&index=0&id=f670bc26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f670bc26",
  null
  
)

export default component.exports